import React, { useState } from "react";
import PropTypes from "prop-types";
import "./index.sass";
import { LocalStorage } from "../../../shared";

const LOCALE_CHOSEN_KEY = "locale_chosen";

const getPersistedActiveLocale = () => {
	if (LocalStorage.getItem(LOCALE_CHOSEN_KEY) !== "1") {
		return null;
	}
	return LocalStorage.getItem("locale");
};

const LanguageList = ({ className, onChange, languageOptions }) => {
	const [activeLocale, setActiveLocale] = useState(getPersistedActiveLocale);

	const handleSelect = (value) => {
		LocalStorage.setItem(LOCALE_CHOSEN_KEY, "1");
		setActiveLocale(value);
		onChange(value);
	};

	return (
		<div className={`LanguageList ${className}`}>
			<div>
				{languageOptions.map((option) => (
					<button
						key={option.value}
						type="button"
						className={
							activeLocale === option.value ? "LanguageList__selected" : ""
						}
						value={option.value}
						onClick={() => handleSelect(option.value)}
					>
						{option.name}
					</button>
				))}
			</div>
		</div>
	);
};

LanguageList.propTypes = {
	className: PropTypes.string,
	languageOptions: PropTypes.arrayOf(PropTypes.object),
	onChange: PropTypes.func
};

LanguageList.defaultProps = {
	className: "",
	onChange: () => {},
	languageOptions: [
		{ name: "PT", value: "pt" },
		{ name: "EN", value: "en" },
		// { name: "ES", value: "es" }
	]
};

export default LanguageList;
